export const headersPhysicalSpaces = [
  {
    text: "Id Espacio Físico",
    value: "idSync",
    sortable: false,
    align: "center",
  },
  {
    text: "Nombre",
    value: "name",
    sortable: false,
    align: "center",
  },
  {
    text: "Sucursal",
    value: "name",
    sortable: false,
    align: "center",
  },
  {
    text: "Tipo de espacio físico",
    value: "name",
    sortable: false,
    align: "center",
  },
  {
    text: "Activo",
    value: "active",
    sortable: false,
    align: "center",
  },
  {
    text: "Estatus",
    value: "status",
    sortable: false,
    align: "center",
  },
  {
    text: "Acciones",
    value: "actions",
    sortable: false,
    align: "center",
  },
];

export const headersSync = [
  {
      text: 'Id Sincronización',
      value: 'idSync',
      sortable: false,
      align: 'center',
      
  },
  {
      text: 'Origen',
      value: 'origen',
      sortable: false,
      align: 'center',
  },
  {
      text: 'Destino',
      value: 'destino',
      sortable: false,
      align: 'center',
  },
  {
      text: 'Fecha de sincronización',
      value: 'fecha',
      sortable: false,
      align: 'center',
  },
]

export const headersLogs = [
  {
    text: "Id Log",
    value: "idLog",
    sortable: false,
  },
  {
    text: "Entidad",
    value: "entidad",
    sortable: false,
  },
  {
    text: "Id Entidad 1a",
    value: "idEntidad",
    sortable: false,
  },
  {
    text: "Id Entidad 2da",
    value: "idEntidad2",
    sortable: false,
  },
  {
    text: "Método",
    value: "accion",
    sortable: false,
  },
  {
    text: "Fecha del registro",
    value: "fecha",
    sortable: false,
  },
  {
    text: "Sincronizar",
    value: "actions",
    sortable: false,
  },
]
